/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import TablePageSizeItem from './TablePageSizeItem'

interface TablePageSizeItemsListProps {
    items: number[]
    optionLabels?: Record<number, string>
}

const TablePageSizeItemsList = (props: TablePageSizeItemsListProps) => {
    if (!props.items.length) {
        return null
    }

    return (
        <>
            {props.items.map((item, index) => (
                <TablePageSizeItem
                    key={index}
                    item={item}
                    label={props.optionLabels?.[item] ?? String(item)}
                />
            ))}
        </>
    )
}

export default TablePageSizeItemsList
